import React from "react";

const ScreenLoader = () => {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <p>Loading...</p>
    </div>
  );
};

export default ScreenLoader;
